/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';

import { POST_SD_EXTERNALUSER_LINK_ACCOUNT } from './actionTypes';

import { postSdExternaluserLinkAccountUtil } from './utils';

/**
 * Contains the action creator functions that update the ExternalUserLinkAccount slice of the store.
 *
 * @namespace ExternalUserLinkAccountActions
 */
export default class actions {
  /**
   * Calls the api and dispatches the results to the store.
   * api: /v1/ua/sd_externaluser_link_account
   *
   * @param {NewLinkAccountDetails} data object that will be posted to the api
   * @param {function} callback function to call once this function has finished
   * @function
   * @memberof ExternalUserLinkAccountActions
   */
  static postSdExternaluserLinkAccount = (dispatch, newLinkAccountDetails, callback) => {
    ReduxUtils.generateAction(
      dispatch,
      postSdExternaluserLinkAccountUtil.bind(null, newLinkAccountDetails),
      POST_SD_EXTERNALUSER_LINK_ACCOUNT,
      callback
    );
  };

  /**
   * Dispatches the data to the store to reset the data cached from a call to postSdExternaluserLinkAccount.
   *
   * @param {function} dispatch
   * @param {Object} data object to be set in the store.
   * @function
   * @memberof ExternalUserLinkAccountActions
   */
  static resetPostSdExternaluserLinkAccount = (dispatch, data) => {
    const json = {
      type: POST_SD_EXTERNALUSER_LINK_ACCOUNT.successAction,
      payload: data,
    };
    dispatch(json);
  };

  /**
   * Dispatches the data to the store to reset the error cached from a call to postSdExternaluserLinkAccount.
   *
   * @param {function} dispatch
   * @function
   * @memberof ExternalUserLinkAccountActions
   */
  static resetPostSdExternaluserLinkAccountError = dispatch => {
    ReduxUtils.resetErrorAction(dispatch, POST_SD_EXTERNALUSER_LINK_ACCOUNT.failureAction);
  };
}
